<template>
    <div class="palette gutter frame frame--top">
        <slot :palette="palette">
            <h3 class="palette__heading mb">
                <a class="palette__link" href="/colors" @click.prevent="activatePalette(palette.id)">
                    {{ palette.name }}
                </a>
            </h3>
        </slot>
        <div class="relative">
            <palette-handle v-if="!isActivePalette" class="put-left"></palette-handle>
            <ul class="swatches" :class="{'will-delete-swatch': getWillDeleteStatus}">
                <container @drag-start="dragStart" @drop="drop" @drag-end="dragEnd" :get-child-payload="getPayload"
                           orientation="horizontal" group-name="swatches" drag-class="dragging">
                    <draggable v-for="(swatch, index) in palette.swatches" :key="'swatch-' + index">
                        <swatch :color="swatch.color" :palette-id="palette.id" :swatch-index="index"/>
                    </draggable>
                </container>
                <palette-options v-if="!isActivePalette"
                                 :palette="palette"
                                 @edit="activatePalette"
                                 @duplicate="onDuplicate"
                                 @delete="onDelete"/>
                <add-swatch-button v-else @willDeleteStatusChanged="getWillDeleteStatus" @deleted="isDragging = false"
                                   :is-dragging="isDragging"/>
            </ul>
        </div>
    </div>
</template>

<script>
    import PaletteHandle  from "../../../../../Lib/Icons/PaletteHandle";
    import IconDuplicate  from "../../../../../Lib/Icons/IconDuplicate";
    import IconShare      from "../../../../../Lib/Icons/IconShare";
    import IconTrash      from "../../../../../Lib/Icons/IconTrash";
    import IconX          from "../../../../../Lib/Icons/IconX";
    import PaletteOptions from "./PaletteOptions";
    import AddSwatchButton        from "./AddSwatchButton";
    import {Container, Draggable} from "vue-smooth-dnd";
    import ActivePalette          from "../../../Store/ActivePalette";
    import Swatch                 from "./Swatch";
    import Palettes               from "../../../Store/Palettes";
    import Swatches               from "../../../Store/Swatches";

    export default {
        name: "Palette",
        components: {
            Swatch,
            AddSwatchButton,
            PaletteOptions,
            PaletteHandle,
            IconDuplicate,
            IconShare,
            IconTrash,
            IconX,
            Container,
            Draggable,
        },

        props: {
            palette: {},
            isActivePalette: {
                default: false,
            },
        },

        data() {
            return {
                isDragging: false,
                palettes: new Palettes(),
            }
        },

        methods: {

            drop(event) {
                if(event.removedIndex == null || event.addedIndex == null) return;
                let oldIndex = event.removedIndex, newIndex = event.addedIndex, paletteId = this.palette.id;
                let swatches = new Swatches(paletteId);
                swatches.reorder(oldIndex, newIndex);
                new ActivePalette().activate(paletteId, newIndex);
            },

            dragEnd() {
                this.isDragging = false;
            },

            dragStart(event) {
                this.isDragging = true;
            },

            getWillDeleteStatus(willDelete) {
                return willDelete;
            },

            async onDelete() {
                let id = this.palette.id;
                this.palettes.delete(this.palette);
                this.$emit('deleted', id);
            },

            async onDuplicate() {
                this.palettes.duplicate(this.palette);

                this.$router.push({name: 'colors'});
            },

            getPayload(index) {
                return {index};
            },

            activatePalette(paletteId) {
                new ActivePalette().activate(paletteId, 0);
                this.$router.push({name: 'colors'});
            },
        },
    }
</script>

<style lang="scss" scoped>
    .will-delete-swatch {
        overflow: visible;
    }

    .smooth-dnd-ghost {
        width: 4rem !important;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
    }
</style>
